import * as React from "react";
const IconAppointment = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M57 11.8h-4.3V6.9c0-.6-.4-1-1-1s-1 .4-1 1v4.9H13.3V6.9c0-.6-.4-1-1-1s-1 .4-1 1v4.9H7c-2.8 0-5 2.2-5 5v36.3c0 2.8 2.2 5 5 5h50c2.8 0 5-2.2 5-5V16.8c0-2.8-2.2-5-5-5m-50 2h4.3v4.8c0 .6.4 1 1 1s1-.4 1-1v-4.8h37.3v4.8c0 .6.4 1 1 1s1-.4 1-1v-4.8H57c1.7 0 3 1.3 3 3v8.3H4v-8.3c0-1.7 1.3-3 3-3m50 42.3H7c-1.7 0-3-1.3-3-3v-26h56v26c0 1.7-1.3 3-3 3" />
    <path d="M38.4 40.6H33v-5.4c0-.6-.4-1-1-1s-1 .4-1 1v5.4h-5.4c-.6 0-1 .4-1 1s.4 1 1 1H31V48c0 .6.4 1 1 1s1-.4 1-1v-5.4h5.4c.6 0 1-.4 1-1s-.5-1-1-1" />
  </svg>
);
export default IconAppointment;
